import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
export const SUPABASE_ANON = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const DEFAULT_TENANT = (import.meta.env.VITE_DEFAULT_TENANT as string) || 'major-high';
export const DEFAULT_COURSE_SLUG = (import.meta.env.VITE_DEFAULT_COURSE as string) || 'formacao-lideres-mentores';
export const DATASOURCE = (import.meta.env.VITE_DATASOURCE as string) || 'supabase';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: localStorage,
  },
});
export const isSupabase = () => DATASOURCE === 'supabase';

// Function to determine default role based on email
export const getDefaultRole = (email: string): 'student' | 'instructor' | 'admin' => {
  if (email.includes('admin') || email.includes('owner')) {
    return 'admin';
  }
  if (email.includes('instructor') || email.includes('teacher')) {
    return 'instructor';
  }
  return 'student';
};

